type TOrderable = { id: string; created_at: string | Date; position?: number };

const time = (value: string | Date) => new Date(value).getTime();

/**
 * Sort comparator for records shown in a list: by position if they have one, then oldest first, then id.
 * Never ties, so an edited row stays where it was - records saved together share a created_at.
 */
export const byPosition = (a: TOrderable, b: TOrderable) =>
  (a.position ?? 0) - (b.position ?? 0) ||
  time(a.created_at) - time(b.created_at) ||
  (a.id < b.id ? -1 : a.id > b.id ? 1 : 0);

/** Sort comparator: newest first, ties by id */
export const byNewest = (a: TOrderable, b: TOrderable) =>
  time(b.created_at) - time(a.created_at) || (a.id < b.id ? -1 : a.id > b.id ? 1 : 0);

/** A comparator's ties broken by id, so the order never depends on how the records arrived */
export function thenById<T extends { id: string }>(compare: (a: T, b: T) => number) {
  return (a: T, b: T) => compare(a, b) || (a.id < b.id ? -1 : a.id > b.id ? 1 : 0);
}
